export const REQUIRED_OFFSET = [0, -12]; // We need this to make the marker sit on top of route instead of blocking it

export const POPUP_REQUIRED_X_OFFSET = -10; // Initially anchor="center" is not exactly center

export const MARKER_SIZE = { width: 32, height: 40 };

export const OFFSET_PADDING = { x: 5, y: 5 };
